module.exports = __webpack_public_path__ + "img/test-9-11-4.099b0d2a.png";